import { z } from 'zod'

import {
  BidIdSchema,
  ProjectIdSchema,
  UserIdSchema,
} from '../unique-id.models.ts'
import { ActivityLinkTargets } from './activity-data.models.ts'
import { ActivityTypeAndDataSchema } from './utilities.ts'

export const ProjectOfferPendingActivityDetailsSchema =
  ActivityTypeAndDataSchema(
    'project_offer_pending',
    z.object({
      projectId: ProjectIdSchema,
      bidId: BidIdSchema,
      acceptorId: UserIdSchema,
      ...ActivityLinkTargets('project'),
    })
  )
